<template>
  <v-container id="data-tables" tag="section">
    <base-material-card color="indigo" icon="mdi-chair-school" inline class="px-5 py-3">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Courses</div>
      </template>

      <v-toolbar class="mb-5" color="white" flat>
        <v-btn color="primary" @click.stop="createNew()">New item</v-btn>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto mr-5"
          label="Search"
          hide-details
          single-line
          style="max-width: 250px;"
        />
      </v-toolbar>
      <v-row justify="end" style="margin:0px;padding:0px;height:30px;">
        <v-switch v-model="tableView" label="Table" style="margin:0px;padding:0px;height:30px;" />
      </v-row>
      <template v-if="tableView">
        <v-data-table
          :headers="headers"
          :items="items"
          :search.sync="search"
          :sort-by="['dateFrom']"
          :sort-desc="[true, false]"
          multi-sort
        >
          <template v-slot:item.start="{ item }">
            <span>{{item.start | moment("YYYY-MM-DD HH:mm")}}</span>
          </template>
          <template v-slot:item.end="{ item }">
            <span>{{item.end | moment("YYYY-MM-DD HH:mm")}}</span>
          </template>

          <template v-slot:item.teachersNames="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on" v-html="getTeacherNames(item.teachersNames)"></span>
              </template>
              <span v-html="getTeacherNames(item.teachersNames, true)"></span>
            </v-tooltip>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon class="mr-2" @click="editItem(item)">mdi-lead-pencil</v-icon>
            <v-icon @click="deleteItem(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </template>
      <template v-else>
        <v-row class="fill-height">
          <v-col>
            <v-sheet height="64">
              <v-toolbar flat color="white">
                <v-btn fab text small @click="prev">
                  <v-icon small>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn fab text small @click="next">
                  <v-icon small>mdi-chevron-right</v-icon>
                </v-btn>
                <v-toolbar-title>{{title}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-menu bottom right>
                  <template v-slot:activator="{ on }">
                    <v-btn outlined v-on="on">
                      <span>{{ typeToLabel[type] }}</span>
                      <v-icon right>mdi-menu-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="type = 'day'">
                      <v-list-item-title>Day</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = 'week'">
                      <v-list-item-title>Week</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = 'month'">
                      <v-list-item-title>Month</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = '4day'">
                      <v-list-item-title>4 days</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-toolbar>
            </v-sheet>

            <v-sheet height="600">
              <v-calendar
                ref="calendar"
                color="primary"
                :event-name="formatEvent"
                :events="calendarFilter"
                :event-margin-bottom="3"
                :type="type"
                v-model="focus"
                @click:event="showEvent"
                @click:more="showMore"
                @change="updateRange"
              ></v-calendar>
              <v-menu
                v-model="selectedOpen"
                color="grey lighten-4"
                :close-on-content-click="false"
                :activator="selectedElement"
                full-width
                offset-x
                left
                z-index="9999"
              >
                <v-card color="grey lighten-4" min-width="350px" flat>
                  <iframe
                    :src="getMap(selectedEvent)"
                    width="100%"
                    height="300"
                    frameborder="0"
                    style="border:0"
                    allowfullscreen
                  />

                  <v-toolbar :color="selectedEvent.color" dark>
                    <v-toolbar-title v-html="selectedEvent.courseName"></v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>

                  <v-card-text>
                    <span class="mr-1">
                      <b>Teachers</b>
                    </span>
                    <span>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <span v-on="on" v-html="getTeacherNames(selectedEvent.teachersNames)"></span>
                        </template>
                        <span v-html="getTeacherNames(selectedEvent.teachersNames, true)"></span>
                      </v-tooltip>
                    </span>
                    <br />

                    <span class="mr-1">
                      <b>Seats</b>
                    </span>
                    <span v-html="selectedEvent.availableSeats"></span>
                    <br />

                    <span class="mr-1">
                      <b>Adress</b>
                    </span>
                    <span
                      v-html="'('+ selectedEvent.adressExtraInfo +') '+ selectedEvent.adress +' '+selectedEvent.zipCode +', '+ selectedEvent.city"
                    ></span>
                    <br />

                    <span class="mr-1">
                      <b>Start</b>
                    </span>
                    <span>{{selectedEvent.start | moment("YYYY-MM-DD HH:mm")}}</span>
                    <br />

                    <span class="mr-1">
                      <b>End</b>
                    </span>
                    <span>{{selectedEvent.end | moment("YYYY-MM-DD HH:mm")}}</span>
                    <br />
                  </v-card-text>

                  <v-card-actions>
                    <v-btn text color="secondary" @click="selectedOpen = false">Cancel</v-btn>

                    <v-btn text color="primary" @click="editItem(selectedEvent)">Edit</v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>

              <v-menu
                v-model="viewMoreOpen"
                :close-on-content-click="false"
                :activator="viewMoreElement"
                color="grey lighten-4"
                allow-overflow
                top
                max-width="160"
                max-height="200"
              >
                <v-card color="grey lighten-4" class="ma-0" flat>
                  <v-card-text>
                    <v-chip
                      v-for="event in viewMoreEvents"
                      v-bind:key="event.id"
                      :ref="`chip_${event.id}`"
                      @click="showEvent({event: event})"
                      color="primary"
                      class="ma-0 mb-1 text-center justify-center"
                      style="width:100%;"
                      x-small
                      label
                    >{{ event.courseName }} - {{ event.availableSeats }}</v-chip>
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-sheet>
          </v-col>
        </v-row>
      </template>
    </base-material-card>

    <v-dialog v-if="Dialog.dialog" v-model="Dialog.dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Are you sure?</v-card-title>
        <v-card-actions>
          <v-btn color="green darken-1" text @click="Dialog.dialog = false">No</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="Dialog.deleteAction();Dialog.dialog = false"
          >Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="text-center ma-2">
      <v-snackbar
        v-model="Snackbar.visible"
        :timeout="Snackbar.timeout"
        :color="Snackbar.color"
      >{{ Snackbar.snackbarText }}</v-snackbar>
    </div>
  </v-container>
</template>

<script>
import TrainingApi from "../../../servcies/api/training/Training";
import _ from "lodash";

export default {
  name: "Training",

  data: () => ({
    tableView: true,

    type: "month",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days"
    },
    start: null,
    end: null,
    focus: null,

    selectedEvent: {},
    selectedElement: null,
    selectedOpen: null,

    viewMoreEvents: [],
    viewMoreElement: null,
    viewMoreOpen: null,

    headers: [
      {
        text: "Course type",
        value: "courseName"
      },
      {
        text: "From",
        value: "start"
      },
      {
        text: "To",
        value: "end"
      },
      {
        text: "Adress extra",
        value: "adressExtraInfo"
      },
      {
        text: "Adress",
        value: "adress"
      },
      {
        text: "City",
        value: "city"
      },
      {
        text: "Postal",
        value: "zipCode"
      },
      {
        text: "Seats",
        value: "availableSeats"
      },
      {
        text: "Teachers",
        value: "teachersNames"
      },
      {
        sortable: false,
        text: "Actions",
        value: "actions"
      }
    ],
    items: [],
    search: undefined,
    Dialog: {
      item: null,
      dialog: false,
      deleteAction: () => {}
    },
    Snackbar: {
      snackbarText: "",
      visible: false,
      timeout: 5000,
      color: "error"
    }
  }),

  created() {
    this.init();
  },
  mounted() {
    if (this.$refs.calendar) this.$refs.calendar.checkChange();
  },

  computed: {
    calendarFilter() {
      const { search } = this;
      if (!search) return this.items;

      return _.filter(this.items, o => {
        return (
          this.calendarFilterComparer(search, o.teachersNames) ||
          this.calendarFilterComparer(search, o.availableSeats) ||
          this.calendarFilterComparer(search, o.adress) ||
          this.calendarFilterComparer(search, o.adressExtraInfo) ||
          this.calendarFilterComparer(search, o.city) ||
          this.calendarFilterComparer(search, o.zipCode) ||
          this.calendarFilterComparer(search, o.courseName)
        );
      });
    },

    title() {
      const { start, end } = this;
      if (!start || !end) {
        return "";
      }

      const startMonth = this.monthFormatter(start);
      const endMonth = this.monthFormatter(end);
      const suffixMonth = startMonth === endMonth ? "" : endMonth;

      const startYear = start.year;
      const endYear = end.year;
      const suffixYear = startYear === endYear ? "" : endYear;

      const startDay = start.day + this.nth(start.day);
      const endDay = end.day + this.nth(end.day);

      switch (this.type) {
        case "month":
          return `${startMonth} ${startYear}`;
        case "week":
        case "4day":
          return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`;
        case "day":
          return `${startMonth} ${startDay} ${startYear}`;
      }
      return "";
    },
    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: "UTC",
        month: "long"
      });
    }
  },

  methods: {
    getTeacherNames(teacherNames, takeAll = false) {
      var names = "";

      if (teacherNames) {
        if (!takeAll && teacherNames.length > 3) {
          names = teacherNames.slice(0, 3).join(", ");
          names +=
            teacherNames.length >= 4 ? ` (+${teacherNames.length - 3})` : ``;
        } else names = teacherNames.join(", ");
      }

      return names;
    },

    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    getMap(item) {
      return encodeURI(
        "https://www.google.com/maps/embed/v1/place?key=AIzaSyAk29-4F4Qwr0ZwXK2xxIK3rRylq_DLUdc&q=" +
          item.adress +
          "," +
          item.city
      );
    },
    getInnermostHovered() {
      var hoverElements = document.querySelector(":hover");
      var innerHoverElements;
      while (hoverElements) {
        innerHoverElements = hoverElements;
        hoverElements = innerHoverElements.querySelector(":hover");
      }
      return innerHoverElements;
    },

    showMore({ date }) {
      this.focus = date;

      const open = () => {
        this.viewMoreEvents = this.getEventsByDate(date);
        this.viewMoreElement = this.getInnermostHovered
          ? this.getInnermostHovered()
          : this.selectedElement;
        setTimeout(() => (this.viewMoreOpen = true), 10);
      };

      if (this.viewMoreOpen) {
        this.viewMoreOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }
    },

    showEvent({ nativeEvent, event }) {
      if (!nativeEvent) {
        nativeEvent = { target: this.$refs[`chip_${event.id}`][0].$el };
      }

      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      if (nativeEvent && nativeEvent.stopPropagation)
        nativeEvent.stopPropagation();
    },

    getEventsByDate(date) {
      var selectedDate = new Date(date);

      return _.filter(this.items, item => {
        if (!item.start || !item.end) return false;

        var startDate = new Date(item.start.split("T")[0]);
        var endDate = new Date(item.end.split("T")[0]);

        return startDate <= selectedDate && selectedDate <= endDate;
      });
    },

    formatEvent(event, flag) {
      return event.input.courseName + " - " + event.input.city;
    },

    init() {
      let loader = this.$loading.show();

      TrainingApi.getTrainings()
        .then(result => {
          this.items = result;
          loader.hide();
        })
        .catch(err => {
          this.Snackbar.snackbarText = err;
          this.Snackbar.visible = true;
          loader.hide();
        });
    },
    createNew() {
      this.$router.push("courseCreate");
    },

    deleteItem(item) {
      this.Dialog.dialog = true;
      this.Dialog.item = item;

      this.Dialog.deleteAction = () => {
        let loader = this.$loading.show();
        const index = this.items.indexOf(item);
        var id = item.id;

        TrainingApi.deleteTraining(id)
          .then(response => {
            this.items.splice(index, 1);
            loader.hide();
          })
          .catch(error => {
            this.Snackbar.snackbarText = error;
            this.Snackbar.visible = true;
            loader.hide();
          });
      };
    },

    editItem(item) {
      var id = item.id;
      this.$router.push({ path: `courseEdit/${id}` });
    },

    updateRange({ start, end }) {
      // You could load events from an outside source (like database) now that we have the start and end dates on the calendar
      this.start = start;
      this.end = end;
    },
    nth(d) {
      return d > 3 && d < 21
        ? "th"
        : ["th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th"][d % 10];
    },

    calendarFilterComparer(searchValue, itemValue) {
      return _.lowerCase(itemValue).indexOf(_.lowerCase(searchValue)) != -1;
    }
  }
};
</script>

<style>
</style>
